var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidelinesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_739_1779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0H4.66668C2.82868 0 1.33334 1.49533 1.33334 3.33333V12.6667C1.33334 14.5047 2.82868 16 4.66668 16H11.3333C13.1713 16 14.6667 14.5047 14.6667 12.6667V3.33333C14.6667 1.49533 13.1713 0 11.3333 0ZM6.66668 12.6667C6.66668 13.0347 6.36801 13.3333 6.00001 13.3333H4.66668C4.29868 13.3333 4.00001 13.0347 4.00001 12.6667V11.3333C4.00001 10.9653 4.29868 10.6667 4.66668 10.6667H6.00001C6.36801 10.6667 6.66668 10.9653 6.66668 11.3333V12.6667ZM6.66668 8.66667C6.66668 9.03467 6.36801 9.33333 6.00001 9.33333H4.66668C4.29868 9.33333 4.00001 9.03467 4.00001 8.66667V7.33333C4.00001 6.96533 4.29868 6.66667 4.66668 6.66667H6.00001C6.36801 6.66667 6.66668 6.96533 6.66668 7.33333V8.66667ZM6.66668 4.66667C6.66668 5.03467 6.36801 5.33333 6.00001 5.33333H4.66668C4.29868 5.33333 4.00001 5.03467 4.00001 4.66667V3.33333C4.00001 2.96533 4.29868 2.66667 4.66668 2.66667H6.00001C6.36801 2.66667 6.66668 2.96533 6.66668 3.33333V4.66667ZM11.3333 12.6667H8.66668C7.79468 12.6627 7.79534 11.3373 8.66668 11.3333H11.3333C12.2053 11.3373 12.2047 12.6627 11.3333 12.6667ZM11.3333 8.66667H8.66668C7.79468 8.66267 7.79534 7.33733 8.66668 7.33333H11.3333C12.2053 7.33733 12.2047 8.66267 11.3333 8.66667ZM11.3333 4.66667H8.66668C7.79468 4.66267 7.79534 3.33733 8.66668 3.33333H11.3333C12.2053 3.33733 12.2047 4.66267 11.3333 4.66667Z",
    fill: "#3B60E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_1779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelinesActive);
export default __webpack_public_path__ + "static/media/guidelinesActive.002e84f27e3122dba1fd4fb8a43262b1.svg";
export { ForwardRef as ReactComponent };